// Ceremony.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaCalendarAlt, FaClock, FaTshirt, FaMapMarkerAlt, FaBuilding, FaCity, FaDoorOpen, FaChurch, FaGlassCheers, FaParking, FaMapMarkedAlt } from 'react-icons/fa';
import './Ceremony.css';
import ceremonyImage from '../../images/wedding/welcome-party.jpg';

const Ceremony = () => {
    const { t } = useTranslation();

    const handleMapClick = (e) => {
        e.preventDefault();
        const address = encodeURIComponent('Jernbanevegen 26, 2900 Fagernes, Norge');
        window.open(`https://www.google.com/maps/search/?api=1&query=${address}`, '_blank');
    };

    return (
        <section className="ceremony-section">
            <div className="ceremony-container">
                <div className="ceremony-content">
                    <h2 className="ceremony-title">{t('ceremony.title')}</h2>

                    <div className="ceremony-details">
                        <p className="ceremony-date"><FaCalendarAlt className="icon" /> {t('ceremony.date')}</p>
                        <p className="ceremony-time"><FaClock className="icon" /> {t('ceremony.time')}</p>
                        <p className="ceremony-dress"><FaTshirt className="icon" /> {t('ceremony.dress')}</p>

                        <div className="ceremony-location">
                            <p className="venue-name"><FaBuilding className="icon" /> {t('ceremony.venue')}</p>
                            <p className="venue-address"><FaMapMarkerAlt className="icon" /> {t('ceremony.address')}</p>
                            <p className="venue-city"><FaCity className="icon" /> {t('ceremony.city')}</p>
                        </div>

                        <div className="ceremony-instructions">
                            <p className="doors-info"><FaDoorOpen className="icon" /> {t('ceremony.doorsOpen')}</p>
                            <p className="ceremony-start"><FaChurch className="icon" /> {t('ceremony.location')}</p>
                            <p className="after-party"><FaGlassCheers className="icon" /> {t('ceremony.afterParty')}</p>
                            <p className="parking-info"><FaParking className="icon" /> {t('ceremony.parking')}</p>
                        </div>

                        <a href="#" className="map-link" onClick={handleMapClick}>
                            <FaMapMarkedAlt className="icon" /> {t('ceremony.mapLink')}
                        </a>
                    </div>
                </div>

                <div className="ceremony-image">
                    <img src={ceremonyImage} alt={t('ceremony.imageAlt')} />
                </div>
            </div>
        </section>
    );
};

export default Ceremony;